export enum NftScreenEnum {
  NFT = 'prizes',
  GAME = 'games'
}
